<template>
  <v-img
      v-if="imageUrl || fallbackImageUrl"
      class="image-with-loader"
      @click="handleImageClick"
      :src="imageUrl">
    <template v-slot:placeholder>
      <div class="image-with-loader--placeholder">
        <icon-ypo-white :height="iconSize" :width="iconSize"></icon-ypo-white>
      </div>
    </template>
  </v-img>
</template>

<script>
import IconYpoWhite from "@/components/Icons/IconYpoWhite.vue";

export default {
  name: 'YpoImageWithLoader',
  components: { IconYpoWhite },
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    fallbackImageUrl: {
      type: String,
      required: false,
    },
    clickCallback: {
      type: Function,
      required: false,
      default: () => {},
    },
    iconSize: {
      type: Number,
      required: false,
      default: 40,
    },
  },
  data: () => {
    return {};
  },
  methods: {
    imageErrorFallback() {
      return `this.src='${this.fallbackImageUrl || ''}';this.onerror=null;`;
    },
    handleImageClick() {
      if (this.clickCallback) this.clickCallback();
    },
  },
};
</script>

<style lang="scss">
@import '../../common/styles/_colors.scss';

.image-with-loader {
  height: 100%;
  width: 100%;
  position: relative;

  &--placeholder {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: $ypo-light-gray;
    border-radius: 4px;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, rgba(255, 255, 255, 0) 25%, rgba(200, 200, 200, 0.5) 50%, rgba(255, 255, 255, 0) 75%);
      animation: shimmer 2s infinite linear;
    }
  }

  @keyframes shimmer {
    100% {
      left: 100%;
    }
  }
}
</style>
